import { gql, makeVar, type TypePolicies, useQuery } from '@apollo/client'

export const GET_SELECTED_FLEETS = gql`
  query getSelectedFleets {
    getSelectedFleets @client
  }
`

export const useSelectedFleets = (): [string[], boolean] => {
  const { data } = useQuery(GET_SELECTED_FLEETS)
  const loading = false

  return [data?.getSelectedFleets ?? [], loading]
}

export const selectedFleetsVar = makeVar<string[]>([])

export const selectFleets = (fleetIds: string[]) => {
  selectedFleetsVar(fleetIds)
}

export const MoiaSelectedFleetsTypePolicies: TypePolicies = {
  Query: {
    fields: {
      getSelectedFleets: {
        read(): string[] {
          return selectedFleetsVar()
        },
      },
    },
  },
}
